import { currentLocale } from '@/i18n'

/** Colours of the alignment map's V1 boards, the Hindi voice, and keypad typing. */
export const C = {
  bg: '#fbf9f5',
  surface: '#ffffff',
  ink: '#221e1f',
  muted: '#5f5852',
  border: '#8a827a',
  rule: '#d9d1c3',
  acc: '#a15f1e',
  accDark: '#8a4f12',
  sunk: '#f6ece0',
  warnWash: '#fbeacf',
  photo: '#d8ccb4',
  photoInk: '#6b5e2f',
  ok: '#2f6b3a',
  okWash: '#e3eedf',
  bad: '#b3402e',
  badWash: '#f8e2dc',
  help: '#2f5d8c',
  helpWash: '#e3ebf4',
  dim: '#57524d',
  scanner: '#2b2724',
  slate: '#38403a',
  slateEdge: '#6f6a62',
} as const

// Voice: the speaker buttons read the line aloud in the language on screen (the phone's own voice, offline).
export function speak(text: string) {
  try {
    const s = window.speechSynthesis
    if (!s) return
    s.cancel()
    const u = new SpeechSynthesisUtterance(text)
    u.lang = currentLocale() === 'hi' ? 'hi-IN' : 'en-IN'
    u.rate = 0.9
    s.speak(u)
  } catch {
    // no voice on this phone: the words are on the screen
  }
}

/** Applies a keypad key to a typed string (max digits after the dot, max length). */
export function typeKey(cur: string, k: string, opts: { decimals?: number; max?: number } = {}) {
  const { decimals = 2, max = 7 } = opts
  if (k === '⌫') return cur.slice(0, -1)
  if (k === '.') {
    if (decimals === 0 || cur.includes('.')) return cur
    return (cur === '' ? '0' : cur) + '.'
  }
  const dotAt = cur.indexOf('.')
  if (dotAt >= 0 && cur.length - dotAt > decimals) return cur
  if (cur.replace('.', '').length >= max) return cur
  // Kilos and % drop a leading 0; printed numbers keep theirs ("004127").
  if (decimals > 0 && cur === '0') return k
  return cur + k
}
